import { Components, Inputs } from "@thisgorilla/primate-ds";
import { Formik } from "formik";
import styled, { useTheme } from "styled-components";
import { API_CALLS } from "../../../../../API/api_calls";
import {
  Divider,
  hideScrollBar,
  LabelContainer,
} from "../../../../../commonStyles";
import { ArticleProps } from "../../../../../redux/slices/article/Article";
import { isFormSubmitButtonDisabled } from "../../../../../utils";
import { FlexRowEnd } from "../../../../Common/Styles";
import Input from "../../../../Input";
import { useFindContent } from "../../useFindContent";
import VideoProps from "./Video";

const VideoCreate = ({
  id,
  setIsVideoCreated,
  onDeleteVideo,
}: VideoProps.VideoCreateProps) => {
  const { typography } = useTheme();
  const {
    content_data,
    article_order,
    content_id,
    content_type,
    row_config,
    post_id,
  } = useFindContent(id) as ArticleProps.WithVideoContent;
  const { title, description } = content_data;

  return (
    <Formik
      initialValues={{ video_title: title, video_description: description }}
      onSubmit={() => {}}
      enableReinitialize
    >
      {(formik) => {
        const { values, setFieldValue, validateField } = formik;
        const remainingCharacters =
          500 - (values.video_description?.length ?? 0);

        return (
          <VideoCreateContainer>
            <FlexRowEnd>
              <Components.IconButton
                disabled={false}
                iconType="X"
                kind="Secondary"
                size="Small"
                onClick={onDeleteVideo}
              />
            </FlexRowEnd>
            <Divider />
            <LabelContainer>
              <Components.Text
                style={{ tokenStyle: typography.Heading.XXS }}
                text="Video Headline"
                fontWeight="font-weight-semibold"
                lineHeight="line-height-50"
              />
            </LabelContainer>
            <Input
              fieldName="video_title"
              idPrefix="create-video"
              isRequired
              placeholder="Add a headline to your video"
              size="Medium"
            />
            <LabelContainer>
              <Components.Text
                style={{ tokenStyle: typography.Heading.XXS }}
                text="Description"
                fontWeight="font-weight-semibold"
                lineHeight="line-height-50"
              />
            </LabelContainer>
            <Inputs.Textarea
              fieldName="video-description"
              idPrefix="create-video"
              isRequired
              placeholder="Text"
              size="Medium"
              value={values.video_description}
              onChangeHandler={(value) => {
                setFieldValue(
                  "video_description",
                  value.slice(0, 500),
                  false
                ).then(() => {
                  validateField("video_description");
                });
              }}
              helpText={
                remainingCharacters === 0
                  ? "Max characters reached"
                  : remainingCharacters <= 50
                  ? `${remainingCharacters} characters remaining`
                  : undefined
              }
            />
            <FlexRowEnd>
              <Components.Button
                color="Primary"
                kind="Primary"
                disabled={isFormSubmitButtonDisabled({
                  formik,
                  requiredFileds: {
                    video_title: true,
                    video_description: true,
                  },
                })}
                label="Save"
                onClick={() => {
                  API_CALLS.ARTICLE.createOrUpdateArticleContent({
                    article_order,
                    content_type,
                    post_id,
                    content_id,
                    element_role: row_config.element_role,
                    content_data: JSON.stringify({
                      title: formik.values.video_title,
                      description: formik.values.video_description,
                    }),
                  }).then(() => {
                    setIsVideoCreated(true);
                  });
                }}
                size="Medium"
              />
            </FlexRowEnd>
          </VideoCreateContainer>
        );
      }}
    </Formik>
  );
};

export default VideoCreate;

const VideoCreateContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-6"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};

  * {
    ${hideScrollBar}
  }
`;
